module.exports = __webpack_public_path__ + "static/img/6-4.c27a250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/6-4.png
// module id = uDp4
// module chunks = 25